// For Tabs
export const VENDOR_TAB_LIGHT = 'vendor_tab_light';
export const VENDOR_TAB_SCENE = 'vendor_tab_scene';
export const VENDOR_TAB_THERMO = 'vendor_tab_thermostat';
export const VENDOR_TAB_CURTAIN = 'vendor_tab_curtain';
export const VENDOR_TAB_DDK = 'vendor_tab_digital_door_key';
export const VENDOR_TAB_DOOR_LOCK = 'vendor_tab_door_lock';
export const VENDOR_TAB_DOOR_CAMERA = 'vendor_tab_door_camera';
export const VENDOR_TAB_DND = 'vendor_tab_dnd';
export const VENDOR_TAB_MMR = 'vendor_tab_mmr';

// For the Drawer
export const VENDOR_CREATE_LIGHT = 'vendor_create_light';
export const VENDOR_EDIT_LIGHT = 'vendor_edit_light';
export const VENDOR_CREATE_SCENE = 'vendor_create_scene';
export const VENDOR_EDIT_SCENE = 'vendor_edit_scene';
export const VENDOR_CREATE_CURTAIN = 'vendor_create_curtain';
export const VENDOR_EDIT_CURTAIN = 'vendor_edit_curtain';
export const VENDOR_CREATE_THERMO = 'vendor_create_thermostat';
export const VENDOR_EDIT_THERMO = 'vendor_edit_thermostat';
export const VENDOR_CREATE_DDK = 'vendor_create_digital_door_key';
export const VENDOR_EDIT_DDK = 'vendor_edit_digital_door_key';
export const VENDOR_CREATE_DOOR_LOCK = 'vendor_create_door_lock';
export const VENDOR_EDIT_DOOR_LOCK = 'vendor_edit_door_lock';
export const VENDOR_CREATE_DOOR_CAMERA = 'vendor_create_door_camera';
export const VENDOR_EDIT_DOOR_CAMERA = 'vendor_edit_door_camera';
export const VENDOR_CREATE_DND = 'vendor_create_dnd';
export const VENDOR_EDIT_DND = 'vendor_edit_dnd';
export const VENDOR_CREATE_MMR = 'vendor_create_mmr';
export const VENDOR_EDIT_MMR = 'vendor_edit_mmr';

// For Detail View
export const VENDOR_VIEW_LIGHT = 'vendor_view_light';
export const VENDOR_VIEW_SCENE = 'vendor_view_scene';
export const VENDOR_VIEW_THERMO = 'vendor_view_thermostat';
export const VENDOR_VIEW_CURTAIN = 'vendor_view_curtain';
export const VENDOR_VIEW_DDK = 'vendor_view_digital_door_key';
export const VENDOR_VIEW_DOOR_LOCK = 'vendor_view_door_lock';
export const VENDOR_VIEW_DOOR_CAMERA = 'vendor_view_door_camera';
export const VENDOR_VIEW_DND = 'vendor_view_dnd';
export const VENDOR_VIEW_MMR = 'vendor_view_mmr';

// Vendor Types
export const LIGHT = 'LIGHTS';
export const SCENE = 'SCENES';
export const THERMO = 'THERMOSTAT';
export const CURTAIN = 'CURTAINS';
export const DDK = 'DIGITAL_DOOR_KEY';
export const DOOR_LOCK = 'DOOR_LOCK';
export const DOOR_CAMERA = 'DOOR_CAMERA';
export const DND = 'DND';
export const MMR = 'MMR';

// Vendor Attribute List
export const vendorAttributeList = [
  {
    id: 1,
    name: 'RCU IP',
    value: 'RCU_IP',
  },
  {
    id: 2,
    name: 'RCU ID',
    value: 'RCU_ID',
  },
  {
    id: 3,
    name: 'RCU Port',
    value: 'RCU_PORT',
  },
  {
    id: 4,
    name: 'Relay Id',
    value: 'RELAY_ID',
  },
  {
    id: 5,
    name: 'Power',
    value: 'POWER',
  },
  {
    id: 6,
    name: 'Data Point',
    value: 'DATA_POINT',
  },
  {
    id: 7,
    name: 'Read Address',
    value: 'READ_ADDRESS',
  },
  {
    id: 8,
    name: 'Write Address',
    value: 'WRITE_ADDRESS',
  },
  {
    id: 9,
    name: 'Slave Address',
    value: 'SLAVE_ADDRESS',
  },
  {
    id: 10,
    name: 'Image URL',
    value: 'IMAGE_URL',
  },
];

// Extra Attributes for Thermostats
export const thermostatAttributes = [
  {
    id: 11,

    name: 'Room Temperature',
    value: 'ROOM_TEMPERATURE',
  },
  {
    id: 12,
    name: 'Thermostat Temperature',
    value: 'THERMOSTAT_TEMPERATURE',
  },
  {
    id: 13,
    name: 'Minimum Temperature',
    value: 'MINIMUM_TEMPERATURE',
  },
  {
    id: 14,
    name: 'Maximum Temperature',
    value: 'MAXIMUM_TEMPERATURE',
  },
  {
    id: 15,
    name: 'Temperature Step',
    value: 'TEMPERATURE_STEP',
  },
  {
    id: 16,
    name: 'Temperature Unit',
    value: 'TEMPERATURE_UNIT',
  },
  {
    id: 17,
    name: 'Fan Speed',
    value: 'FAN_SPEED',
  },
  {
    id: 18,
    name: 'Fan Speed Def',
    value: 'FAN_SPEED_DEF',
  },
  {
    id: 19,
    name: 'Fan Mode Def',
    value: 'FAN_MODE_DEF',
  },
  {
    id: 20,
    name: 'Slave Address',
    value: 'SLAVE_ADDRESS',
  },
];

export const thermostatCustomAttribute = [
  'ROOM_TEMPERATURE',
  'THERMOSTAT_TEMPERATURE',
  'MINIMUM_TEMPERATURE',
  'MAXIMUM_TEMPERATURE',
  'TEMPERATURE_STEP',
  'TEMPERATURE_UNIT',
  'FAN_SPEED',
  'FAN_SPEED_DEF',
  'FAN_MODE_DEF',
  'SLAVE_ADDRESS',
];
